import React from 'react';
import ModalDocumentActionButtons from '../common/ModalDocumentActionButtons';

export type ProgramTableDocumentExportButtonsProps = {
  onSaveExcel: () => void;
  onSavePdf: () => void;
  onPrint: () => void;
  disabled?: boolean;
  busy?: boolean;
};

const ProgramTableDocumentExportButtons: React.FC<ProgramTableDocumentExportButtonsProps> = ({
  onSaveExcel,
  onSavePdf,
  onPrint,
  disabled = false,
  busy = false,
}) => (
  <div
    className="cp-program-progress-toolbar-document-actions"
    role="group"
    aria-label="프로그램 내용 엑셀·PDF·프린트"
  >
    <ModalDocumentActionButtons
      onSaveExcel={() => void onSaveExcel()}
      onSavePdf={() => void onSavePdf()}
      onPrint={() => void onPrint()}
      saveDisabled={disabled}
      saveExcelDisabled={disabled}
      printDisabled={disabled}
      busy={busy}
    />
  </div>
);

export default ProgramTableDocumentExportButtons;
